import { Component, Input } from '@angular/core';
import { BubbleLink, MessageBubble } from './message-bubble.interface';
import { CommonModule } from '@angular/common';
import { LinkModule } from '@rogers/cdk/link';
import { IconModule } from '@rogers/cdk/icon';

@Component({
  standalone: true,
  imports: [CommonModule, LinkModule, IconModule],
  selector: 'ucx-message-bubble',
  templateUrl: './message-bubble.component.html',
  styleUrls: ['./message-bubble.component.scss'],
})
export class MessageBubbleComponent {
  @Input()
  messageCopy: MessageBubble['messageCopy'] | undefined;

  @Input()
  showIcon: MessageBubble['showIcon'] = false;

  @Input()
  iconName: MessageBubble['iconName'] = 'location';

  @Input()
  isTypeUser: MessageBubble['isTypeUser'] | undefined;

  @Input()
  links: MessageBubble['links'] | undefined;

  @Input()
  isMessageTypeSame: MessageBubble['isMessageTypeSame'] = true;

  @Input() onClickLink;
  @Input() currentTimestamp;

  onLinkClick(event, link: BubbleLink): void {
    this.onClickLink({ event: event, link: link });
  }
}
